import { Routes } from '@angular/router';

export const unauthorizedRoutes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/unauthorized/unauthorized.module').then(m => m.UnauthorizedModule),
  },
];
